<template>
  <div id="app">
    <transition :name="transitionName">
      <keep-alive>
        <router-view class="page"></router-view>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
  let routerHistory = ['/']
  if (sessionStorage.getItem('routerHistory')) {
    routerHistory = JSON.parse(sessionStorage.getItem('routerHistory'))
  }

  import mutations from '@/store/mutation-types'
  
  import { queryString } from '@/utils'
  
  export default {
    name: 'app',
    data () {
      return {
        transitionName: 'slide-left'
      }
    },
    created () {
      const params = queryString(location.search)

      if (!('token' in params)) {
        this.$store.commit(mutations.update.IS_EXTERNAL_CHANNELS)
      }
    },
    // watch $route 决定使用哪种过渡
    watch: {
      '$route' (to, from) {
        if (to.path === routerHistory[routerHistory.length - 2]) {
          routerHistory.pop()
          this.transitionName = 'slide-right'
        } else {
          routerHistory.push(to.path)
          this.transitionName = 'slide-left'
        }
        sessionStorage.setItem('routerHistory', JSON.stringify(routerHistory))
      }
    }
  }
</script>

<style lang="scss">
  @import './assets/scss/reset';

  html,
  body {
    height: 100%;
  }
  body {
    width: 750px;
    margin: 0;
    margin-left: auto;
    margin-right: auto;
  }
  #app {
    position: relative;
    color: #2c3e50;
    width: 750px;
    height: 100%;
  }
  .slide-right-enter-active,
  .slide-right-leave-active,
  .slide-left-enter-active,
  .slide-left-leave-active {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    will-change: transform;
    transition: all 500ms;
    backface-visibility: hidden;
    perspective: 1000;
  }
  .slide-right-enter,
  .slide-left-leave-active {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
  .slide-right-leave-active,
  .slide-left-enter {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
</style>



// WEBPACK FOOTER //
// App.vue?4ce52edc